import { t } from "../../../services/utils";
import {
  primaryDark60,
  primaryDark80,
  primaryDark40,
  grey600,
} from "../../../constants/colors";
import { STORY_VIEW_WIDTH } from "../../../constants/values";
const padding = 15;
const styles = {
  newPost: {
    // height: "100%",
    maxWidth: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    backgroundColor: "white",
    padding: "16px 20px",
    marginTop: 40,
    borderRadius: 6,
    border: "1px solid #CCC9D5",
  },
  textField: {
    padding: 0,
  },
  toggle: {
    marginBottom: 16,
  },
  postButtons: {
    bottom: 0,
    minWidth: "94%",
    marginBottom: 10,
    display: "flex",
    justifyContent: "space-between",
    marginTop: 50,
    alignItems: "center",
  },
  groupsContainerRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 30,
    flexDirection: "column",
  },
  attachmentsContainer: {
    display: "flex",
    marginBottom: 30,
    width: "98%",
    flexWrap: "wrap",
    marginTop: 15,
  },
  divider: {
    width: STORY_VIEW_WIDTH,
    marginLeft: -16,
    marginTop: 14,
  },
  row: {
    display: "flex",
    flexWrap: "wrap",
  },
  textFieldRow: {
    display: "flex",
    flex: 1,
    // alignItems: "center",
  },

  uploadIcon: {
    color: primaryDark60,
    fontSize: 48,
  },
  iconStyle: {
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  image: {
    height: 50,
    width: 50,
  },
  clear: {
    position: "relative",
    bottom: "40px",
    cursor: "pointer",
  },
  attachments: {
    marginTop: 10,
    display: "flex",
    flexWrap: "wrap",
  },
  fileChip: {
    // width: "44%",
    marginRight: 5,
    marginTop: 5,
  },
  toggle: {
    display: "flex",
    alignItems: "center",
    // justifyContent: "space-between"
  },

  icon: {
    display: "flex",
    alignItems: "center",
    fontSize: 14,
    fontWeight: "500",
    color: primaryDark80,
    marginRight: 10,
    cursor: "pointer",
  },
  label: {
    // paddingLeft: 8,
    fontSize: 14,
    color: primaryDark40,
    fontWeight: "500",
    // transform: "translate(20px, 12px) scale(1)",
  },

  checkbox: {
    width: "unset",
    padding: 5,
    marginRight: 5,
  },
  postOptions: {
    // backgroundColor: "#f6f6f6",
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  },
  icons: {
    display: "flex",
    alignItems: "center",
  },
  button: {
    height: 40,
    marginLeft: 20,
  },
  coverImage: {
    height: 450,
    width: "98%",
    marginTop: 20,
    borderRadius: 5,
  },
  deleteIcon: {
    position: "absolute",
    right: 30,
    marginTop: 30,
    fontSize: 22,
    cursor: "pointer",
  },
  buttons: {
    marginTop: 20,
    display: "flex",
    alignItems: "center",
  },
  submitBtn: {
    marginTop: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
};
export default styles;
